'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./flight-shortcodes.cjs.production.min.js');
} else {
  module.exports = require('./flight-shortcodes.cjs.development.js');
}